import useMainClass from 'hooks/use-main-cass'
import { Link } from 'react-router-dom'

export default function Map() {
  useMainClass('map')

  return (
    <article className={`w-full flex flex-col gap-6 pb-8 px-4 pt-16`}>
      <div className='flex items-center gap-2'>
        <Link to={'/home'}>
          <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.4586 0.0837973L6.26588 0.891081L2.45761 4.69935H13.7245V5.82253H2.45761L6.26588 9.6308L5.4586 10.4381L0.685094 5.66458L0.299002 5.26094L0.685094 4.8573L5.4586 0.0837973Z" fill="white" />
          </svg>
        </Link>
        <h1 className='title medium'>Mapa</h1>
      </div>
      <p className='text big'>Busca tu ciudad en el mapa de las tiendas donde puedes acercarte y participar por increíbles premios.<br />Puedes ver las fechas y horarios de las activaciones debajo del mapa.</p>
      <iframe src="https://www.google.com/maps/d/u/1/embed?mid=1ycRa_69ZKZ8DJUy6hsNr25_aZEeHPyI&ehbc=2E312F&noprof=1" width="640" height="480" className='w-full rounded-2xl'></iframe>
      <h2 className='title medium'>Fechas y horarios de las activaciones:</h2>
      <div className='text medium'>
        <h3 className='text medium'><b>Smart & Final Cetys</b></h3>
        <p className='text medium'>03-05 Octubre | 12-6 pm</p>
      </div>
      <div>
        <h3 className='text medium'><b>Soriana San Nicolás</b></h3>
        <p className='text medium'>03-05 Octubre | 12-6 pm</p>
      </div>
      <div>
        <h3 className='text medium'><b>Chedraui Tenayuca</b></h3>
        <p className='text medium'>03-05, 10-12, 17-19 Octubre | Jue-Sáb 12-6 pm / Dom 11-5 pm</p>
      </div>
      <div>
        <h3 className='text medium'><b>Smart & Final Insurgentes</b></h3>
        <p className='text medium'>03-05 Octubre | 12-6 pm</p>
      </div>
      <div>
        <h3 className='text medium'><b>SC Las Torres</b></h3>
        <p className='text medium'>03-05, 10-12, 17-19, 24-26 Octubre | 12-6 pm</p>
      </div>
      <div>
        <h3 className='text medium'><b>Soriana Ferias</b></h3>
        <p className='text medium'>10-12, 17-19 Octubre | 12-6 pm</p>
      </div>
      <div>
        <h3 className='text medium'><b>SC Niño Obrero</b></h3>
        <p className='text medium'>02-04 Octubre| 8 am-5 pm</p>
      </div>
      <div>
        <h3 className='text medium'><b>Soriana Águilas</b></h3>
        <p className='text medium'>10-12 Octubre | 8 am-5 pm</p>
      </div>
      <div>
        <h3 className='text medium'><b>Soriana Huayacan</b></h3>
        <p className='text medium'>03-05, 10-12, 17-19, 24-26 Oct, 31 Octubre
          - 02 Noviembre | 12-6 pm</p>
      </div>
      <div>
        <h3 className='text medium'><b>Casa Ley Casa Blanca</b></h3>
        <p className='text medium'>03-05, 24-26, 31 Octubre | 12-6 pm</p>
      </div>
      <div>
        <h3 className='text medium'><b>Smart & Final López Mateos</b></h3>
        <p className='text medium'>10-12, 17-19 Octubre | 12-6 pm</p>
      </div>
      <div>
        <h3 className='text medium'><b>Calimax Río</b></h3>
        <p className='text medium'>03-05 Octubre | 12-6 pm</p>
      </div>
      <div>
        <h3 className='text medium'><b>SC Galerías del Vall</b></h3>
        <p className='text medium'>24-28, 30-31 Octubre | 12-6 pm</p>
      </div>
    </article>
  )
}
